/**
 * „Jev“ mit V. (30.09.2026, Tickets 2842/2854)
 *
 * Martin, per Sprechtaste, deutlich verärgert: *„Was ist mit Jev? Und er soll
 * mit V geschrieben sein, verdammt nochmal!“* — und fünf Minuten später noch
 * einmal, mit Vorrang. Die Erkennung hört „Jev“ als „Jef“ oder „Jeff“ (am
 * 30.09. 20:26 „Jeff“, 21:59 „Jef“) — F und V klingen gleich.
 *
 * ## Warum eine eigene, enge Regel
 *
 * `korrigiereBegriffe` (shared/begriffe.ts) greift erst ab acht Buchstaben,
 * `korrigiereEigennamen` (Kölner Phonetik) arbeitet über die Kontakte und ist
 * die gefährlichste Stelle der Kette (762 falsche Wörter am 17.09.). „Jef“
 * hat drei Buchstaben. Hier steht darum eine Regel, die NUR diese Schreibweisen
 * kennt — kein Abstand, keine Phonetik, kein Raten:
 *
 *   Jef, Jeff, JEF, JEFF, Jev, JEV   →  Jev
 *   Jefs, Jeffs, Jeff's, Jevs        →  Jevs
 *
 * ⚠️ Nur für Martins Konto (Konto 1): nur dort gibt es Jev (server/jev.ts).
 *    Wer die Regel für andere Konten einschaltet, schreibt „Jeff“ in
 *    fremden Texten um. Die Aufrufer prüfen das Konto, nicht diese Funktion.
 * ⚠️ „Jeff“ ist auch ein englischer Vorname. Folgt ein bekannter Nachname
 *    (Jeff Bezos), bleibt der Name, wie er ist.
 * ⚠️ Nicht angefasst werden Jeffrey, Jefferson (das Wort geht weiter), Adressen
 *    und Mail-Teile (jeff@…, …/jeff) — dort ist „Jeff“ kein Gesagtes.
 */

/** Nachnamen, bei denen „Jeff“ ein Mensch ist und kein Jev. Klein geschrieben. */
const NACHNAMEN_NACH_JEFF: ReadonlySet<string> = new Set([
  "bezos",
  "bridges",
  "goldblum",
  "buckley",
  "koons",
  "beck",
  "dunham",
  "weiner",
  "atwood",
  "hawkins",
  "immelt",
  "skoll",
  "dean",
]);

/*
 * Wortanfang: kein Buchstabe/keine Ziffer davor, und kein Zeichen, das auf eine
 * Adresse oder einen Dateinamen deutet (/ @ . _ :). Der Bindestrich bleibt
 * erlaubt — „Jef-Abschluss“ ist genau der Fall, um den es geht.
 * Wortende: Genitiv-s (auch mit Apostroph), dann kein Buchstabe/keine Ziffer,
 * und kein @ oder / dahinter.
 */
const MUSTER = /(?<![\p{L}\p{N}/@._:])je(?:ff?|v)(['’]?s)?(?![\p{L}\p{N}@/])/giu;

/**
 * „Jef“, „Jeff“, „JEV“ … → „Jev“ (Mehrzahl/Genitiv „Jevs“).
 *
 * @param merke  wird je Ersetzung mit (vorher, nachher) gerufen — für die
 *               Zeile im Protokoll; nur echte Änderungen, nie „Jev“ → „Jev“.
 */
export function korrigiereJev(text: string, merke?: (vorher: string, nachher: string) => void): string {
  if (!text) return text;
  return text.replace(MUSTER, (treffer: string, genitiv: string | undefined, offset: number, ganz: string) => {
    const danach = /^\s+(\p{L}+)/u.exec(ganz.slice(offset + treffer.length));
    if (danach && NACHNAMEN_NACH_JEFF.has(danach[1]!.toLowerCase())) return treffer;
    const neu = genitiv ? "Jevs" : "Jev";
    if (neu !== treffer) merke?.(treffer, neu);
    return neu;
  });
}
